import React, { Component } from 'react'; // ✅ Fix: import Component
import WelcomeFamphyClinics from './WelcomeFamphyClinics';
import FamilyPhysicians from './FamilyPhysicians';
import ClinicLabTests from './ClinicLabTests';
import ClinicPhysiotheripy from './ClinicPhysiotheripy';
import ClinicVaccinations from './ClinicVaccinations';
import ClinicECG from './ClinicECG';
import TreadmillTest from './TreadmillTest';
import ClinicAudiometry from './ClinicAudiometry';
import ClinicDayCare from './ClinicDayCare';


export default class FamphyClinics extends Component {
  render() {
    return (
      <>
        <div className='Inner-banner'>
          <img
            className="img-fluid"
            src={`${process.env.PUBLIC_URL}/img/famphy-clinic-banner.jpg`}
            alt="Home Visits"
          />
        </div>
        <div className='clinic-visit'>
            <WelcomeFamphyClinics />
            <FamilyPhysicians />
            <ClinicLabTests />
            <ClinicPhysiotheripy />
            <ClinicVaccinations />
            <ClinicECG />
            <TreadmillTest />
            <ClinicAudiometry />           
            <ClinicDayCare/>  
        </div>
      </>
    );
  }
}
